module.exports = __webpack_public_path__ + "media/images/flags/1x1/fra-3489c0d9a9ffa41fcb180058ad7b9a41.svg";